export default __webpack_public_path__ + "static/media/1818.5b8fe206.png";